import ReactGA from 'react-ga4';

export enum AnalyticsEvents {
	LOGIN = 'login',
	LOGOUT = 'logout'
}

class AnalyticsService {
	private trackEvent(eventName: string, parameters?: Record<string, string>) {
		ReactGA.event(eventName, parameters);
	}

	public trackLogin(method = 'email') {
		this.trackEvent(AnalyticsEvents.LOGIN, { method });
	}

	public trackLogout() {
		this.trackEvent(AnalyticsEvents.LOGOUT);
	}
}

export const analyticsService = new AnalyticsService();
